import React, { useRef, useState } from "react";

import SectionTitle from "@app/components/3_modules/sections/SectionTitle";

import { ChevronUp, ChevronDown, Zap, Building } from "lucide-react";
import { useDossier } from "@app/contexts/DossierContext";
import Tabs from "@app/components/2_widgets/Tabs";

import ElectricConsumptionDetail from "@app/components/2_widgets/dossiers/ElectricConsumptionDetail";
import ElectricAnnualConsumption from "@app/components/2_widgets/dossiers/ElectricAnnualConsumption";

export default function ElectricConsumption({ }) {
    const dossier = useDossier();
    
    const [activeTab, setActiveTab] = useState(dossier.structure_datas?.length > 0 ? dossier.structure_datas[0].id : null);

    const tabs = dossier.structure_datas?.map((st_data) => ({eventKey: st_data.id, tabTitle: st_data.structure?.trade_name, icon: <Building />}));

    return (
        <div className="page-section">
            <SectionTitle
                icon={<Zap />}
                title="Consommation Énergétique"                                
            />
            <Tabs
                tabs={tabs}
                onTabChange={setActiveTab}
                activeTab={activeTab}
            />
            <ElectricConsumptionDetail 
                structureDataId={activeTab} 
            />
            <ElectricAnnualConsumption />
        </div>
    )
}